import axios from "axios";


export let ancanaApitoken = null;

try {
  ancanaApitoken = JSON.parse(localStorage?.getItem('user') || '').token;
} catch (e) {

}

/**
 * The tenant this admin works as. Sent as `X-Operator` on every request, and
 * ancana_api scopes both reads and writes to it, so no page has to pick or send
 * an operator itself. Screens about tenants rather than inside one (/tenants)
 * are served by endpoints that ignore the header — that exception lives in the
 * API, not here.
 */
export const actingOperatorId = process.env.REACT_APP_OPERATOR_ID || '1';

/**
 * Every header ancana_api expects. Exported for the antd `Upload` components,
 * which post with their own request and would otherwise skip these.
 */
export const ancanaApiHeaders = {
  'Authorization': ancanaApitoken ? `Token ${ancanaApitoken}` : '',
  'X-Operator': actingOperatorId,
};

export const ancanaApi = axios.create({
  // baseURL: `https://api.ancana.co/v1/`,
  baseURL: `${process.env.REACT_APP_API_URL}/v1/`,
  timeout: 900000,
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    ...ancanaApiHeaders,
  }
});
